module.exports = __webpack_public_path__ + "static/media/flag_vi.a62ad62f.svg";